module.exports = __webpack_public_path__ + "static/media/minion-yahoo.0823eaf6.ogg";